import React from 'react';
import InformationBlock from '../InformationBlock';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetMailingStatisticsCountGame } from '../../../../store/mailing/thunk/setGetMailingStatisticsCountGame';
import { setGetMailingStatisticsCountReplenishment } from '../../../../store/mailing/thunk/setGetMailingStatisticsCountReplenishment';
import { setGetMailingStatisticsCountTransaction } from '../../../../store/mailing/thunk/setGetMailingStatisticsCountTransaction';
import { setGetMailingStatisticsCountWithdrawals } from '../../../../store/mailing/thunk/setGetMailingStatisticsCountWithdrawals';
import { setGetMailingStatisticsDashboard } from '../../../../store/mailing/thunk/setGetMailingStatisticsDashboard';
import OpenGame from '../Tables/OpenGame';
import Replenishment from '../Tables/Replenishment';
import Withdrawals from '../Tables/Withdrawals';
import CountUsersWithdrawals from '../Tables/CountUsersWithdrawals';
import CountUsersDeposits from '../Tables/CountUsersWithDeposits';
import CountUsersTransactions from '../Tables/CountUsersTransaction';

const MDASH = '\u2014';

const TabStatistics = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const { id } = router.query;

    React.useEffect(() => {
        dispatch(setGetMailingStatisticsCountGame({
            id
        }));
        dispatch(setGetMailingStatisticsCountReplenishment({
            id
        }));
        dispatch(setGetMailingStatisticsCountTransaction({
            id
        }));
        dispatch(setGetMailingStatisticsCountWithdrawals({
            id
        }));
        dispatch(setGetMailingStatisticsDashboard({
            id
        }));
    }, [])

    const [activeTab, setActiveTab] = React.useState('count_game');

    const handleChangeBlock = (value) => {
        setActiveTab(value)
    }

    const countOpenGame = useSelector((state) => state.mailing.statistics.count_open_game);
    const countReplenishment = useSelector((state) => state.mailing.statistics.count_replenishment);
    const countWithdrawals = useSelector((state) => state.mailing.statistics.count_withdrawals);
    const transaction = useSelector((state) => state.mailing.statistics.count_transaction);
    const dashboard = useSelector((state) => state.mailing.statistics.dashboard);

    return (
        <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', rowGap: 10 }}>
            <div style={{ display: 'flex', columnGap: 10 }}>
                <InformationBlock
                    label="Кол-во открытых игр"
                    width="170px"
                    lineColor="#f39c12"
                    isActive={activeTab === 'count_game'}
                    name="count_game"
                    handleChange={handleChangeBlock}
                >
                    <span style={{
                        fontWeight: 400,
                        userSelect: 'none',
                        color: '#FFFFFF'
                    }}>{countOpenGame ? new Intl.NumberFormat('ru-RU').format(countOpenGame) : MDASH}</span>
                </InformationBlock>
                <InformationBlock
                    label="Кол-во пользователей с депозитами"
                    width="170px"
                    lineColor="#f39c12"
                    isActive={activeTab === 'count_of_users_with_deposits'}
                    name="count_of_users_with_deposits"
                    handleChange={handleChangeBlock}
                >
                    <span style={{
                        fontWeight: 400,
                        userSelect: 'none',
                        color: '#FFFFFF'
                    }}>{countReplenishment ? new Intl.NumberFormat('ru-RU').format(countReplenishment) : MDASH}</span>
                </InformationBlock>
                <InformationBlock
                    label="Кол-во пользователей без оплаты"
                    width="170px"
                    lineColor="#f39c12"
                    isActive={activeTab === 'count_of_users_without_deposits'}
                    name="count_of_users_without_deposits"
                    handleChange={handleChangeBlock}
                >
                    <span style={{
                        fontWeight: 400,
                        userSelect: 'none',
                        color: '#FFFFFF'
                    }}>{transaction ? new Intl.NumberFormat('ru-RU').format(transaction) : MDASH}</span>
                </InformationBlock>
                <InformationBlock
                    label="Кол-во пользователей с выводами"
                    width="170px"
                    lineColor="#f39c12"
                    isActive={activeTab === 'count_of_users_with_withdrawals'}
                    name="count_of_users_with_withdrawals"
                    handleChange={handleChangeBlock}
                >
                    <span style={{
                        fontWeight: 400,
                        userSelect: 'none',
                        color: '#FFFFFF'
                    }}>
                        {countWithdrawals ? new Intl.NumberFormat('ru-RU').format(countWithdrawals) : MDASH}
                    </span>
                </InformationBlock>
            </div>
            {
                dashboard?.map((item, key) => (
                    <>
                        <div style={{ display: 'flex', columnGap: 10 }}>
                            <InformationBlock
                                label={`Кол-во депозитов ${item.currency}`}
                                width="170px"
                                lineColor="#3cde0b"
                                isActive={activeTab === `count_deposit_${item.currency}`}
                                name={`count_deposit_${item.currency}`}
                                handleChange={handleChangeBlock}
                            >
                                <span style={{
                                    fontWeight: 400,
                                    userSelect: 'none',
                                    color: '#FFFFFF'
                                }}>{new Intl.NumberFormat('ru-RU').format(item.count_deposit)}</span>
                            </InformationBlock>
                            <InformationBlock
                                label={`Сумма депозитов ${item.currency}`}
                                width="170px"
                                lineColor="#3498db"
                                isActive={activeTab === `sum_deposit_${item.currency}`}
                                name={`sum_deposit_${item.currency}`}
                                handleChange={handleChangeBlock}
                            >
                                <span style={{
                                    fontWeight: 400,
                                    userSelect: 'none',
                                    color: '#FFFFFF'
                                }}>{new Intl.NumberFormat('ru-RU').format(item.sum_deposit)}</span>
                            </InformationBlock>
                            <InformationBlock
                                label={`Кол-во выводов ${item.currency}`}
                                width="170px"
                                lineColor="#2ecc71"
                                isActive={activeTab === `count_withdrawals_${item.currency}`}
                                name={`count_withdrawals_${item.currency}`}
                                handleChange={handleChangeBlock}
                            >
                                <span style={{
                                    fontWeight: 400,
                                    userSelect: 'none',
                                    color: '#FFFFFF'
                                }}>{new Intl.NumberFormat('ru-RU').format(item.count_withdrawals)}</span>
                            </InformationBlock>
                            <InformationBlock
                                label={`Сумма выводов ${item.currency}`}
                                width="170px"
                                lineColor="#e74c3c"
                                isActive={activeTab === `sum_withdrawals_${item.currency}`}
                                name={`sum_withdrawals_${item.currency}`}
                                handleChange={handleChangeBlock}
                            >
                                <span style={{
                                    fontWeight: 400,
                                    userSelect: 'none',
                                    color: '#FFFFFF'
                                }}>{new Intl.NumberFormat('ru-RU').format(item.sum_withrawals)}</span>
                            </InformationBlock>
                        </div>
                    </>
                ))
            }
            {
                activeTab === 'count_game' && <OpenGame id={id} />
            }
            {
                (activeTab.includes('sum_deposit') || activeTab.includes('count_deposit')) && <Replenishment id={id} currency={activeTab.slice(-3)} />
            }
            {
                (activeTab.includes('sum_withdrawals') || activeTab.includes('count_withdrawals')) && <Withdrawals id={id} currency={activeTab.slice(-3)} />
            }
            {
                activeTab === 'count_of_users_with_withdrawals' && <CountUsersWithdrawals id={id}/>
            }
            {
                activeTab === 'count_of_users_with_deposits' && <CountUsersDeposits id={id} />
            }
            {
                activeTab === 'count_of_users_without_deposits' && <CountUsersTransactions id={id} />
            }
        </div>
    )
}

export default TabStatistics;